module.exports = __webpack_public_path__ + "static/media/engi.af01794c.JPG";